import { useContext } from 'react';

// project imports
import { ConfigContext } from 'contexts/ConfigContext';

// ==============================|| HOOKS ||============================== //

const useConfig = () => useContext(ConfigContext);

export default useConfig;
